import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/01EarlyBird/EarlyBird.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/03Banner/Carousel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/04UpcomingBatches/BatchCards.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/components/09Companies/logoSlider.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/components/05WhyChooseUs/whychoose.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/components/11FAQs/FAQsection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/12PageBreaker/PageBreak.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/13Footer/FooterWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/14BlogsPage/BlogCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/LeadForm/LeadButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaButton"] */ "/home/runner/work/SOFAR/SOFAR/app/lib/Button.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/lib/ReusableCardComp.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/SOFAR/SOFAR/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
